
import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import CheckFiberInfrastructureBlockData from '../../../Models/Content/CheckFiberInfrastructureBlockData';
import CheckFiberInfrastructure from './checkFiberInfrastructure';
export default class CheckFiberInfrastructureBlock extends EpiComponent<CheckFiberInfrastructureBlockData> {
    public render(): ReactNode | ReactNodeArray | null {

        return (
            <div className='check-fiber-infrastructure-block'>
                <CheckFiberInfrastructure context={this.getContext()} iContent={this.props.data} />
            </div>            
        )
    }
}
